import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { ShelvableBackend } from '../../services/ShelvableBackend/ShelvableBackend'
import { Utilities } from '../../services/Utilities';
import { Shelf } from '../../services/ShelvableBackend/Shelf'
import { FirebaseObjectObservable } from 'angularfire2/database';
import swal from 'sweetalert';
import { Observable } from 'rxjs';

@Component({
    selector: 'user-shelf',
    templateUrl: './user-shelf.html',
    styleUrls: ['./user-shelf.css', './user-shelf.mobile.css'],
    encapsulation: ViewEncapsulation.None
})
export class UserShelfComponent {
    username:string;
    shelfName:string;

    userExists = () => !!this.userId;
    isLoggedInUser = this.shelvableBackend.loggedInUserId.map((userId) => this.userId === userId).shareReplay(1);

    shelf:Shelf;

    makeArrayOfLength:(length:number) => any[] = Utilities.makeArrayOfLength;
    getProfilePictureUrl:(userId:string, lastUpdated:string) => string;
    shelfNameValidity:{message?:string, isValid:boolean};
    
    isLoggedIn:Observable<boolean>;
    loggedInUsername:Observable<string>;
    
    userData:FirebaseObjectObservable<any>

    getBookKey = (index, book) => book.$key;

    constructor(@Inject("userId") public userId:string, stateService:StateService, private shelvableBackend:ShelvableBackend) {
        this.username = stateService.params.username;
        this.shelfName = stateService.params.shelfName;

        this.getProfilePictureUrl = shelvableBackend.getProfilePictureUrl;
        (async () => this.shelfNameValidity = await shelvableBackend.validateShelfName(this.shelfName, false))();

        this.loggedInUsername = shelvableBackend.loggedInUserObs.usernameObs;
        this.isLoggedIn = shelvableBackend.loggedInUserObs.isLoggedIn;
        
        if (this.userExists()) {
            this.shelf = shelvableBackend.getShelf(this.userId, this.shelfName);
            this.userData = shelvableBackend.getUserData(this.userId);
        }
    }
    createShelf() {
        this.shelvableBackend.addShelf(this.shelfName);
    }
    
    removeAtKey(shelf_name, books_array, book) {
        swal({
            title: 'Are you sure you want to remove this book from  "' + shelf_name + '"?',
            showCancelButton: true,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Yes, remove it.",
            cancelButtonText: "No, leave it.",
            closeOnConfirm: true,
            closeOnCancel: true,
            imageUrl: "//books.google.com/books/content?id=" + book.googleId + "&printsec=frontcover&img=1&zoom=1&source=gbs_api"
        },
        function (isConfirmed) {
            if (isConfirmed) {
                books_array.deleteBook(book);
            }
        });
    };
}




// WEBPACK FOOTER //
// ./web/static/components/user-shelf/user-shelf.ts